// extracted by mini-css-extract-plugin
export default {"certificates":"VMainCertificates_certificates__V05AL","wrapper":"VMainCertificates_wrapper__Ofh3Z"};